import { render, staticRenderFns } from "./addPerson.vue?vue&type=template&id=76ac2db6&scoped=true&"
import script from "./addPerson.vue?vue&type=script&lang=js&"
export * from "./addPerson.vue?vue&type=script&lang=js&"
import style0 from "./addPerson.vue?vue&type=style&index=0&id=76ac2db6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ac2db6",
  null
  
)

export default component.exports